// @flow
import React from "react";
import { Card, Section } from "buba-components";
import type { BankOfferSubstatus } from "../../../data/types/bankOffers";
import Timer from "./Timer";
import ActionsForNew from "./ActionsForNew";
import ActionsForOfferSubmitted from "./ActonsForOfferSubmitted";
import ActionsForInProgress from "./ActionsForInProgress";

type ActionsProps = {
  id: number,
  status: BankOfferSubstatus,
  timeInformation: ?string,
  onError: string => void,
  displayErrorForStatusCode: number => void,
  requestFetch: any => void,
  type: "customer" | "bank_advisor"
};

const Actions = ({
  id,
  status,
  timeInformation,
  onError,
  displayErrorForStatusCode,
  requestFetch,
  type
}: ActionsProps) => {
  const isClosed = !["opened", "in_process", "offer_submitted"].includes(status);

  if (isClosed && !timeInformation) {
    return null;
  }

  const sharedActionProps = {
    id,
    onError,
    displayErrorForStatusCode,
    requestFetch
  };

  return (
    <Section title="Aktionen" numbered reducedMargin>
      <Card>
        {type === "customer" && <Timer status={status} timeInformation={timeInformation} />}
        {status === "opened" && <ActionsForNew {...sharedActionProps} />}
        {status === "in_process" && <ActionsForInProgress {...sharedActionProps} />}
        {status === "offer_submitted" && <ActionsForOfferSubmitted {...sharedActionProps} />}
      </Card>
    </Section>
  );
};

export default Actions;
